/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Layout":"Layout_ujoOO","page":"page_dnePO"};